import type { Company } from "../lib/access";

export function CompanySwitcher({
  companies,
  active,
  onChange,
}: {
  companies: Company[];
  active: Company;
  onChange: (id: string) => void;
}) {
  // One person can belong to several companies, so this is always present —
  // it just does not offer a choice when there is only one.
  if (companies.length === 1) return <span className="company">{active.name}</span>;

  return (
    <label className="switcher">
      <span className="sr-only">Active company</span>
      <select value={active.id} onChange={(e) => onChange(e.target.value)}>
        {companies.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>
    </label>
  );
}
